

















































































































































import constants from "@/config/constants";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import rules from "../../utils/rules";
import { isURL } from "../../utils/url-check";
@Component
export default class CreatePhotoDialog extends Vue {
  @Prop() dialogCreate!: boolean;
  @Prop() totalCarousel!: number;
  image = "";
  file = undefined;
  videoURL: string | null = null;
  photoRules = [rules.files];
  generalRules = [rules.notEmpty];
  type = "";
  kind = constants.PHOTO_KIND.PHOTO;
  $refs!: {
    formCreate: HTMLFormElement;
  };

  valid = true;
  loadingCreate = false;
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;

  photoKinds = Object.values(constants.PHOTO_KIND);

  private previewImage(event: any): void {
    if (event) {
      const file = event || event.dataTransfer.files;
      this.file = file;
      this.createImg(file);
    } else {
      this.file = undefined;
      this.image = "";
    }
  }

  private createImg(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.image = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  private cancelCreate(): void {
    this.$emit("cancelCreate");
  }

  private createPhoto(): void {
    this.loadingCreate = true;
    this.$store
      .dispatch("settings/addPhoto", {
        file: this.file,
        photoType: this.type,
        photoKind: this.kind,
        ...(this.videoURL && { photoUrl: this.videoURL }),
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessCreate = true;
        } else {
          this.snackbarErrorCreate = true;
        }

        this.loadingCreate = false;
        this.$emit("cancelCreate");
      });
  }

  private get photoTypes(): Array<string> {
    const types = this.$store.getters["settings/getPhotoTypes"];
    const result = [];

    for (let index = 0; index < types.length; index++) {
      if (types[index] == constants.PHOTO_TYPE.CAROUSEL) {
        if (this.totalCarousel < 6) {
          result.push(types[index]);
        }
      } else {
        result.push(types[index]);
      }
    }
    return result;
  }
  @Watch("type")
  private checkType(type: string) {
    if (type == constants.PHOTO_TYPE.CLIENT) {
      this.kind = constants.PHOTO_KIND.PHOTO;
    }
  }

  get isVideo() {
    return this.kind == constants.PHOTO_KIND.VIDEO;
  }
  get isValidURL() {
    return isURL(this.videoURL || "");
  }
}
